<template>
  <card
    class="custom-shadow-card-header custom-table-responsive"
    :title="`${$t('production.harvest_by_age_week_total')} ${
      getSizeFarmList === 1
        ? ` - ${$t('common_words.farm')}: ${farmList[0].name}`
        : ``
    }`"
  >
    <el-container>
      <aside-list
        :addClass="`.el-menu-${option}`"
        @clickItem="handleChangeMenuSelected"
        :label="$t('common_words.farms')"
        :optionIndex="option"
        :list="farmList"
        v-if="getSizeFarmList > 1"
      />
      <el-container v-if="dataFarm && getSizeFarmList > 0">
        <el-main
          :style="
            getSizeFarmList == 1
              ? 'paddingLeft: 0 !important; overflow: hidden;'
              : ''
          "
        >
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead-by-age-week
                    :columns="dataFarm.columns"
                    labelFirstCell=""
                  />
                  <tfoot-totals-by-age-week
                    :rows="queriedDataRows(dataFarm.rows)"
                    :columns="dataFarm.columns"
                    :totalColumns="dataFarm.totalColumns"
                    :totalRows="dataFarm.totalRows"
                    :option="option"
                  />
                </table>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12" v-if="isExcel()">
              <div class="text-center">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel()"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </card>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import AsideList from 'src/components/Layouts/AsideList.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import PaginationTable from '../pagination-table';
import Select from 'src/components/Selects/Select.vue';
import TheadReportByAgeAndWeek from './TheadReportByAgeAndWeek.vue';
import TbodyReportByAgeAndWeek from './TbodyReportByAgeAndWeek.vue';
import TfootTotalsByAgeAndWeek from './TfootTotalsByAgeAndWeek.vue';

export default {
  name: 'report-by-age-week-total',
  components: {
    [AsideList.name]: AsideList,
    [Select.name]: Select,
    [TheadReportByAgeAndWeek.name]: TheadReportByAgeAndWeek,
    [TbodyReportByAgeAndWeek.name]: TbodyReportByAgeAndWeek,
    [TfootTotalsByAgeAndWeek.name]: TfootTotalsByAgeAndWeek,
    LPagination,
  },
  data() {
    return {
      froms: 0,
      tos: 0,
      totals: 0,
      perPageOptions: [5, 10, 25, 50, 0],
    };
  },
  props: {
    option: {
      type: String,
      default: 'reportByAgeAndWeekTotal',
    },
    farmList: {
      type: Array,
      default: [],
    },
    dataFarm: {
      type: Array | Object,
    },
  },
  computed: {
    getSizeFarmList() {
      if (this.farmList) return Object.keys(this.farmList).length;
      else return 0;
    },
  },
  mixins: [MixinMasters, MixinPermissions],
  methods: {
    ...PaginationTable.Methods,
    handleChangeMenuSelected(data) {
      this.$emit('handleChangeMenuSelected', data);
    },
    exportToExcel() {
      this.$emit('exportToExcel', {
        optionFront: this.option,
        optionBackend: 6,
      });
    },
  },
  watch: {
    dataFarm(value) {
      try {
        this.searchFuse(['name'], this.getRows(this.dataFarm.rows), 0.2);
      } catch (error) {
        console.log(error);
      }
      this.pagination.perPage = 10;
      this.searchQuery = '';
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.getSizeFarmList == 1) {
        this.handleChangeMenuSelected({
          id: this.farmList[0].id,
          option: this.option,
        });
      } else {
        document.getElementsByClassName(`.el-menu-${this.option}`)[0].click();
      }
    }, 100);
  },
};
</script>
